import * as React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import CircularProgress from '@mui/material/CircularProgress';
import { Box, Popper } from '@mui/material';
import Data from '../Types/Data';


function sleep(delay = 0) {
  return new Promise((resolve) => {
    setTimeout(resolve, delay);
  });
}

export default function DoubleTextfield(props: { placeholderCode?: string, placeholderText?: string, data: Array<Data>, mode?: string, register: any, HandleFunction: any }) {
  const [open, setOpen] = React.useState(false);
  const [options, setOptions] = React.useState<readonly Data[]>([]);
  const loading = open && options.length === 0;
  const [code, setCode] = React.useState(String);
  const [libelle, setLibelle] = React.useState(String);

  React.useEffect(() => {
    let active = true;

    if (!loading) {
      return undefined;
    }

    (async () => {
      // await sleep(1e3 / 2);
      if (active) {
        setOptions([...(props.data)]);
      }
    })();

    return () => {
      active = false;
    };
  }, [loading]);

  React.useEffect(() => {
    if (!open) {
      setOptions([]);
    }
  }, [open]);

  return (
    <Box display={'flex'}>
      <Autocomplete
        className={(props.mode == 'light') ? "" : 'd-textfield'}
        id="asynchronous-demo"
        sx={{ width: 500 }}
        open={open}
        onOpen={() => {
          setOpen(true);
        }}
        onClose={() => {
          setOpen(false);
        }}
        isOptionEqualToValue={(option, value) => {
          setLibelle(option.Libelle)
          setCode(option.CodeAgence)
          return option.Libelle === value.Libelle
        }}
        getOptionLabel={(option) => {
          return (option.CodeAgence + " - " + option.Libelle)
        }}
        options={options}
          PopperComponent={(props) => <Popper {...props} disablePortal />}
        // loading={loading}
        renderInput={(params) => (
          <>
            <TextField
              required
              {...props.register}
              onSelect={(e: any) => {
                if (e.target.value !== code) { setCode(e.target.value) };
                if (e.target.value !== "") { // && e.target.value.split(" - ")[0] == code
                  props.HandleFunction(e.target.value.split(" - ")[0])
                }
              }}
              color='success'
              variant='filled'
              {...params}
              label={(props.mode == 'dark') ? "" : '' + props.placeholderText}
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <React.Fragment>
                    {/* {loading ? <CircularProgress color="inherit" size={20} /> : null} */}
                    {params.InputProps.endAdornment}
                  </React.Fragment>
                ),
              }}
            />
          </>
        )}
      />
      {/* <TextField disabled fullWidth className={(props.mode == 'light') ? "" : 'd-textfield' + ' input-code'} color='success' required id="outlined-basic" label={props.placeholderCode} type={"text"} variant="filled" value={libelle} onChange={(e) => { setCode(e.target.value); }} /> */}

    </Box>
  );
}